import { IChecklistTemplateApprovalData } from './IChecklistTemplateApprovalData'
import { Entity } from '@core/entities/entity'
import { TemplateForm } from '@core/entities/template/TemplateForm'
import { plainToInstance, Type } from 'class-transformer'

export class ChecklistTemplateApprovalData extends Entity<IChecklistTemplateApprovalData> {
  id?: string

  label: string

  allowDeletion: boolean

  @Type(() => TemplateForm)
  approvalQuestions?: TemplateForm

  public static new(payload: unknown): ChecklistTemplateApprovalData {
    const entity = plainToInstance(ChecklistTemplateApprovalData, payload)
    return entity
  }
}
